"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Styling_1 = require("office-ui-fabric-react/lib-commonjs/Styling");
var _ = require("underscore");
function invertTheme() {
    var theme = Styling_1.getTheme();
    theme.palette = invertColors(theme.palette);
    theme.isInverted = true;
    return Styling_1.loadTheme(theme);
}
exports.invertTheme = invertTheme;
var colorSwaps = {
    white: 'black',
    neutralDark: 'neutralLighterAlt',
    neutralPrimary: 'neutralLighter',
    neutralPrimaryAlt: 'neutralLight',
    neutralSecondary: 'neutralTertiaryAlt'
};
function invertColors(palette) {
    palette.black = '#222';
    _.each(colorSwaps, function (src, target) {
        var t = palette[target];
        palette[target] = palette[src];
        palette[src] = t;
    });
    return palette;
}
//# sourceMappingURL=colors.js.map